export default function createLazyElementPromise (
  element,
  observerOptions = {
    rootMargin: '50%',
    threshold: 0
  }
) {
  return new Promise((resolve, reject) => {
    const callback = (entries, observer) => {
      const entry = entries[0]
      if (entry.isIntersecting) {
        observer.disconnect()
        resolve(entry.target)
      }
    }
    const observer = new window.IntersectionObserver(callback, observerOptions)
    observer.observe(element)
  })
}
